import { combineReducers, Dispatch, Action, AnyAction } from "redux";
import { connectRouter, RouterState } from "connected-react-router";
import { all, fork } from "redux-saga/effects";
import { History } from "history";

// 登陆验证模块
import { AuthorizationState } from "./authorization/types";
import { authorizationReducer } from "./authorization/reducer";
import authorizationSaga from "./authorization/sagas";

// 主页模块
import { HomeState } from "./home/types";
import { homeReducer } from "./home/reducer";
import homeSaga from "./home/sagas";

/**
 * 最上一级的state
 *
 * @export
 * @interface ApplicationState
 */
export interface ApplicationState {
  /********** 路由 **********/
  router: RouterState;

  /********** 公共模块 **********/
  authorizationState: AuthorizationState;

  /********** 主页模块 **********/
  homeState: HomeState;
}

// 添加属性给react组件，此属性默认传递给connect()方法
export interface ConnectedReduxProps<A extends Action = AnyAction> {
  dispatch: Dispatch<A>
}

// 当action被调度, Redux根据名称去匹配reducer，然后更新相应的state
export const rootReducer = (history: History) => combineReducers<ApplicationState>({
  /********** 路由 **********/
  router: connectRouter(history),

  /********** 公共模块 **********/
  authorizationState: authorizationReducer,

  /********** 主页模块 **********/
  homeState: homeReducer
});

// 合并saga
export function* rootSaga() {
  yield all([
    /********** 公共模块 **********/
    fork(authorizationSaga),

    /********** 主页模块 **********/
    fork(homeSaga)
  ])
}
